import React from 'react';
import LoadingSpinner from 'component/LoadingSpinner';

interface LoadingOverlayProps {
  loading: boolean;
  message?: string;
}

const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ 
  loading, 
  message = "Loading..." 
}) => {
  if (!loading) return null;
  
  return (
    <div className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
         style={{ 
           backgroundColor: 'rgba(255, 255, 255, 0.85)', 
           zIndex: 1055,
           borderRadius: '0.3rem'
         }}>
      <div className="text-center">
        <LoadingSpinner />
        <p className="mt-2 fw-medium">{message}</p>
      </div>
    </div>
  );
};

export default LoadingOverlay;